import { ArrowRight, Layers } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function HeroPlataforma() {
  return <section data-section-id="REEMPLAZAR" id="hero-plataforma" className="bg-background text-foreground relative overflow-hidden py-20 md:py-28 lg:py-32">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,hsl(var(--primary)/0.05)_0%,transparent_70%)] pointer-events-none" />
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 mb-6">
            <Layers className="size-4 text-primary" />
            <span className="text-xs font-mono uppercase tracking-wider text-primary">
              La plataforma
            </span>
          </div>
          <h1 className="font-default text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-white">
            Todo tu cumplimiento PLD/AML{" "}
            <span className="text-primary font-mono">en un solo sistema</span>
          </h1>
          <p className="mt-6 text-lg md:text-xl text-slate-400 font-default leading-relaxed max-w-3xl mx-auto">
            Notalia reúne identificación de clientes, screening contra listas oficiales, generación de avisos y resguardo de expedientes en una sola plataforma. Diseñada para los sujetos obligados del Art. 17 LFPIORPI, sin importar el giro.
          </p>
          <div className="mt-10 flex flex-col items-center gap-3">
            <a href="https://panel.notalia.app/register" target="_blank" rel="noopener noreferrer">
              <Button size="lg" className="px-8 h-14 text-lg font-semibold bg-primary hover:bg-primary/90 text-primary-foreground transition-all duration-200">
                Empieza gratis
                <ArrowRight className="ml-2 size-5" />
              </Button>
            </a>
            <p className="text-xs text-muted-foreground font-mono">
              14 días de Pro completo sin tarjeta. Cancela cuando quieras.
            </p>
          </div>
        </div>
      </div>
    </section>;
}